import { fetch } from '../../utils';
import Backend from '../../backend';

export const vertexGenerateWithTextStreaming = async (
  promptIdentifier,
  promptData,
  existingMessages,
  setText = null,
  completeAction = null,
  setLoading = null
) => {
  try {
    for (let data in promptData) {
      if (!promptData[data]) {
        promptData[data] = '';
      }
    }
    await fetch(Backend.methodUrl('vertexGenerateWithTextStreaming'), {
      method: 'POST',
      body: JSON.stringify({
        promptIdentifier,
        promptData,
        existingMessages
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let responseText = '';

        function read() {
          reader.read().then(({ done, value }) => {
            if (done) {
              if (completeAction) {
                completeAction(responseText);
              }
              if (setLoading) {
                setLoading(false);
              }
              return;
            }
            const text = decoder.decode(value, { stream: true });
            responseText += text;
            if (setText) {
              setText(responseText);
            }
            read();
          });
        }
        read();
      })
      .catch(error => {
        console.error('Error streaming data:', error);
      });
  } catch (error) {
    throw error;
  }
};

export const vertexCountTokens = async (model, contents) => {
  return fetch(Backend.methodUrl('vertexCountTokens'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ model, contents })
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
